import { CrudApi } from './CrudApi';
import { ProductModel } from '../models/product/ProductModel';

class ProductApi extends CrudApi<ProductModel>{
	constructor() {
		super('product', (obj) => new ProductModel().load(obj));
	}
}
export const productApi = new ProductApi();